import {call, put} from "redux-saga/effects";
import {
  setLoading,
  setError,
  setPharmacistList,
  setNewPharmacist,
  setFilteredPharmacists,
  setProcessing,
  setPharmacistFormError
} from "../../slices/pharmacistSlice";
import {
  requestNewPharmacistCreation,
  requestPharmacistList
} from "../requests/pharmacistService";
import {toast} from "react-toastify";

function* handleFetchPharmacists(action) {
  try {
    yield put(setLoading())
    const response = yield call(() => requestPharmacistList(action.payload))
    yield put(setPharmacistList(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

function* handleCreatePharmacist(action) {
  const {pharmacist} = action.payload
  try {
    yield put(setProcessing())
    const response = yield call(() => requestNewPharmacistCreation(pharmacist))
    yield put(setNewPharmacist(response.data))
    toast.success("Pharmacist created successfully!")
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setPharmacistFormError(errMsg));
    toast.error(errMsg)
  }
}

function* handleFilterPharmacist(action) {
  const {query, pharmacists} = action.payload
  try {
    let result
    yield put(setProcessing())
    if (query.length > 0) {
      result = pharmacists.filter((p) => {
        const fullName = `${p.first_name} ${p.last_name}`
        return fullName.toLowerCase().includes(query.toLowerCase())
      })
    } else {
      result = []
    }
    yield put(setFilteredPharmacists(result))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  }
}


export {handleFetchPharmacists, handleCreatePharmacist, handleFilterPharmacist}
